import { Currency } from './components/fields/Currency'
import { DateFormat } from './components/fields/DateFormat'
import { DistanceFormat } from './components/fields/DistanceFormat'
import { Language } from './components/fields/Language'
import { TimeFormat } from './components/fields/TimeFormat'

export function LanguageAndFormatsForm() {
  return (
    <>
      <Language />

      <DateFormat />

      <TimeFormat />

      <DistanceFormat />

      <Currency />
    </>
  )
}
